import {

    CORE_GET_ALL_MASTER_HR_SALARY_REQUEST,
    CORE_GET_ALL_MASTER_HR_SALARY_SUCCESS,
    CORE_GET_ALL_MASTER_HR_SALARY_FAILURE,

    CORE_GET_ALL_HR_SALARY_REQUEST,
    CORE_GET_ALL_HR_SALARY_SUCCESS,
    CORE_GET_ALL_HR_SALARY_FAILURE,

    CORE_GET_MASTER_HR_SALARY_BY_ID_REQUEST,
    CORE_GET_MASTER_HR_SALARY_BY_ID_SUCCESS,
    CORE_GET_MASTER_HR_SALARY_BY_ID_FAILURE,

    CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_REQUEST,
    CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_SUCCESS,
    CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_FAILURE,

    CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_REQUEST,
    CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_SUCCESS,
    CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_FAILURE,

    CORE_GET_SETTING_HR_REQ_REQUEST,
    CORE_GET_SETTING_HR_REQ_SUCCESS,
    CORE_GET_SETTING_HR_REQ_FAILURE,


} from '../../masterDataTypes'

import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterHrSalary: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_MASTER_HR_SALARY_REQUEST:
                return state
            case CORE_GET_ALL_MASTER_HR_SALARY_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_ALL_MASTER_HR_SALARY_FAILURE:
                return {}
            default:
                return state
        }
    },
    reqHrSalary: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_MASTER_HR_SALARY_BY_ID_REQUEST:
                return state
            case CORE_GET_MASTER_HR_SALARY_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_MASTER_HR_SALARY_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    },
    reqHrSalarys: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_HR_SALARY_REQUEST:
                return state
            case CORE_GET_ALL_HR_SALARY_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_HR_SALARY_FAILURE:
                return []
            default:
                return state
        }
    },
    typeHrSalarys: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_REQUEST:
                return state
            case CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_REQ_MASTER_REPORT_TYPE_FAILURE:
                return []
            default:
                return state
        }
    },
    typeHrSalary: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_REQUEST:
                return state
            case CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_BY_ID_REQ_MASTER_REPORT_TYPE_FAILURE:
                return []
            default:
                return state
        }
    },
    hrSalarySetting: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_SETTING_HR_REQ_REQUEST:
                return state
            case CORE_GET_SETTING_HR_REQ_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_SETTING_HR_REQ_FAILURE:
                return []
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/salary/salaryCertificate.js